











 
















const node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AddReflectTemplatePromptMutation_team",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ReflectPrompt",
      "kind": "LinkedField",
      "name": "prompt",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "sortOrder",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "question",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "groupColor",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "TemplatePromptItem_prompt"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "TemplatePromptItem_prompts"
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "description",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "templateId",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "AddReflectTemplatePromptPayload",
  "abstractKey": null
};

(node ).hash = "d82e568156423a1ff1faebe85fdd1e44";

export default node;
